import { useState } from 'react'
import InfoPoint from 'components/common/InfoPoint'
import CloseButton from 'components/common/CloseButton'

interface ViewPortfolioModalProps {
  onClose: () => void
  onSubmit: (address: string) => void
}

function ViewPortfolioModal({ onClose, onSubmit }: ViewPortfolioModalProps) {
  const [address, setAddress] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!address.trim()) {
      setError('Please enter a valid address')
      return
    }
    onSubmit(address.trim())
  }

  const handleAddressChange = (value: string) => {
    setAddress(value)
    if (error) setError('')
  }

  return (
    <div className="tx-form">
      <CloseButton cb={onClose} />
      <div className="title">
        <div className="is-flex">
          <InfoPoint value="View Portfolio" sub="Enter an address to view their portfolio" />
        </div>
      </div>

      <div className="amount-box">
        <div className="input-container">
          <div className="center">
            <input
              className="form-input"
              value={address}
              onChange={(e) => handleAddressChange(e.target.value)}
            />
            <p className="value">Portfolio Address</p>
          </div>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="review-buttons">
        <button
          className="sp-btn primary large full-w send-btn"
          onClick={handleSubmit}
          disabled={!address.trim()}>
          View Portfolio
        </button>
      </div>
    </div>
  )
}

export default ViewPortfolioModal
